import { capitalize } from '@plato/web-util/strings';
import { intlFormatDistance } from 'date-fns';
import { useLocale } from '../../../../lib/hooks/use-locale.ts';

type MinimumUnit = 'minute' | 'day';

type FromNowProps = {
    date?: string | number | Date | null;
    children?: string | number | Date | null;
    minimumUnit?: MinimumUnit;
};

const unitScale: Record<MinimumUnit, number> = {
    minute: 60_000,
    day: 24 * 60 * 60_000,
};

export const FromNow = ({ date, children, minimumUnit = 'day' }: FromNowProps) => {
    const { locale } = useLocale();

    const dateValue = date ?? children;

    if (!dateValue) {
        return null;
    }

    const laterDate = new Date(dateValue);
    const earlierDate = new Date();

    const intervalMs = laterDate.getTime() - earlierDate.getTime();
    const scale = unitScale[minimumUnit];

    const result = intlFormatDistance(laterDate, earlierDate, {
        locale: locale,
        numeric: 'auto',
        unit: Math.trunc(intervalMs / scale) === 0 ? minimumUnit : undefined,
    });

    return capitalize(result);
};
